import DarkMode from '@mui/icons-material/DarkMode';
import LanguageIcon from '@mui/icons-material/Language';
import LightMode from '@mui/icons-material/LightMode';
import MenuIcon from '@mui/icons-material/Menu';
import TranslateIcon from '@mui/icons-material/Translate';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useStyles } from '../styles';
import { LangMenu } from './LangMenu';
import { HelpSearch } from './SearchBox';
import { VersionSelector } from './VersionSelector';
interface HeaderProps {
  handleDrawerToggle: () => void;
  handleDarkModeChange: () => void;
  handleLanguageChange: (language: string) => void;
  handleVersionChange: (version: string) => void;
  handleTranslationChange: () => void;
  language: string;
  versions: string[];
  apiVersion: string;
  darkMode: boolean;
  isLargeScreen: boolean;
  translated: boolean;
}

const Header: React.FC<HeaderProps> = ({
  handleDrawerToggle,
  handleDarkModeChange, 
  handleLanguageChange,
  handleVersionChange,
  handleTranslationChange,
  language,
  versions,
  apiVersion,
  darkMode,
  isLargeScreen,
  translated
}) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" sx={classes.appBar}>
      <Toolbar>
        {
          isLargeScreen ?  (
            <Link href="/" sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src="/revit.svg"
                    alt="Revit API"
                    style={{ height: '40px', cursor: 'pointer' }}
                />
            </Link>
          ) : (
          <IconButton edge="start" sx={classes.menuButton} color="inherit" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
          )
        }
        <Typography variant="h6" sx={{ mr: 4 }}>
          Revit API
        </Typography>
        <VersionSelector
          changeVersion={handleVersionChange}
          versions={versions}
          apiVersion={apiVersion}
        />
        <Box sx={{flexGrow: 1}} />
        <Box sx={{ minWidth: '300px' }} >
            <HelpSearch apiVersion={apiVersion}/>        
        </Box>


        <LangMenu changeLanguage={handleLanguageChange} selectedLanguage={language} />
        <IconButton color="inherit" onClick={handleDarkModeChange}>
          {darkMode ? <DarkMode /> : <LightMode />}
        </IconButton>
        <IconButton color="inherit" onClick={handleTranslationChange}>
          {translated ? <TranslateIcon /> : <LanguageIcon />}
        </IconButton>        
      </Toolbar>
    </AppBar>
  );
};

export default Header;